export enum FeedbackType {
  Positive = 'up',
  Negative = 'down',
}
